import { Component, OnInit } from '@angular/core'
import { GroupsService } from '../../services/groups.service'
import { MessagesDelegate } from '../../services/messages-delegate.service'
import { EventsEmitterService } from '../../services/events-emitter.service'

import { Group } from '../../models/group.model'
import { config } from '../../config/config'

@Component({
  selector: 'ld-groups-list',
  template: require('./groups-list.component.html'),
  styles: [require('./groups-list.component.css')]
})
export class GroupsListComponent implements OnInit {

  private groups: Group[] = []
  private filteredGroups: Group[] = []
  private pages: number[] = []
  private pagesCount = 0
  private activePage = 0
  private showPagination = true

  constructor (
    private groupsService: GroupsService,
    private messagesDelegate: MessagesDelegate,
    private eventsEmitter: EventsEmitterService
    ) {}

  async ngOnInit () {
    this.groups = await this.groupsService.get()
        .catch((e) => {
          this.messagesDelegate.add('APP.GROUPLIST.ERROR')
          return []
        })
    this.filteredGroups = this.groups
    this.showPage(0)
  }

  filter (value) {
    if (value.trim() === '') {
      this.showPagination = true
      this.showPage(0)
    } else {
      this.showPagination = false
      const search = new RegExp(value.trim(), 'gi')
      this.filteredGroups = this.groups.filter(group => group.name.match(search))
    }
  }

  showPage (pageNumber: number) {
    // active page
    this.activePage = pageNumber

    // pages displayed in pagination menu
    this.pagesCount = Math.ceil(this.groups.length / config.pagination.itemsPerPage)
    this.pages = Array(this.pagesCount)
      .fill(0)
      .map((x,i) => i)
      .filter((p) =>
        this.activePage < 2 && p < config.pagination.maxPagesDisplayed ||
          this.activePage > 0 && this.activePage < this.pagesCount - config.pagination.maxPagesDisplayed && p >= this.activePage - 2 && p <= this.activePage + 2 ||
        this.activePage >= this.pagesCount - config.pagination.maxPagesDisplayed && p >= this.pagesCount - config.pagination.maxPagesDisplayed
      )

    this.filteredGroups = this.groups.slice(pageNumber * config.pagination.itemsPerPage, (pageNumber + 1) * config.pagination.itemsPerPage)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/groups-list/groups-list.component.ts